module.exports = __webpack_public_path__ + "img/bul_user_lock.c5790d09.svg";